export default __webpack_public_path__ + "c6e1a87808b0ba690dafa35c20399609.png";